import React from 'react';

import { CheckCircle, HourglassEmpty } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Clear';
import {
  Alert,
  AlertTitle,
  Box,
  CircularProgress,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

import { MakeMeAnOfferStepStatus } from '~/services/AccommodationService';

export interface MakeMeAnOfferCreateStatusProps {
  name?: string;
  offerUrl?: string;
  status: {
    createOffer: MakeMeAnOfferStepStatus;
    createProperty: MakeMeAnOfferStepStatus;
    createPackages: MakeMeAnOfferStepStatus;
    createSchedules: MakeMeAnOfferStepStatus;
    createAvailability: MakeMeAnOfferStepStatus;
  };
}

export default function MakeMeAnOfferCreateStatus({ name, offerUrl, status }: MakeMeAnOfferCreateStatusProps) {
  const { createOffer, createProperty, createPackages, createSchedules, createAvailability } = status;

  const steps = [
    { label: 'Offer Created', status: createOffer },
    { label: 'Property Created', status: createProperty },
    { label: 'Packages Created', status: createPackages },
    { label: 'Schedules Created', status: createSchedules },
    { label: 'Availability Set', status: createAvailability },
  ];

  const allCompleted =
    createOffer === 'completed' &&
    createProperty === 'completed' &&
    createPackages === 'completed' &&
    createSchedules === 'completed' &&
    createAvailability === 'completed';

  return (
    <Box>
      <Typography variant="h6">Offer Creation Status</Typography>

      <List>
        {steps.map((step, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              {step.status === 'completed' && <CheckCircle color="success" />}
              {step.status === 'awaiting' && <HourglassEmpty color="disabled" />}
              {step.status === 'processing' && <CircularProgress size={20} />}
              {step.status === 'failed' && <DeleteIcon color="error" />}
            </ListItemIcon>
            <ListItemText primary={step.label} />
          </ListItem>
        ))}
      </List>

      {allCompleted && (
        <Alert severity="success">
          <AlertTitle>Offer Successfully Created!</AlertTitle>
          <Link href={offerUrl} target="_blank">
            {name}
          </Link>
        </Alert>
      )}
    </Box>
  );
}
